import { useCallback, useState } from "react";

import { DynamicThemeContext } from "./DynamicThemeContext";
import PropTypes from "prop-types";
import { isMerry } from "../../utils/isMerry";
import { isSpooky } from "../../utils/isSpooky";

const STORAGE_KEY = "hcc.dynamicThemeEnabled";

// localStorage can throw (private mode, blocked storage): fall back to enabled
const readPreference = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) !== "false";
    } catch {
        return true;
    }
};

export const DynamicThemeProvider = ({ children }) => {
    const [dynamicThemeEnabled, setEnabled] = useState(readPreference);

    const setDynamicThemeEnabled = useCallback((enabled) => {
        setEnabled(enabled);
        try {
            localStorage.setItem(STORAGE_KEY, String(enabled));
        } catch {
            // Preference just won't persist across reloads
        }
    }, []);

    return (
        <DynamicThemeContext.Provider
            value={{
                hasDynamicTheme: isSpooky() || isMerry(),
                dynamicThemeEnabled,
                setDynamicThemeEnabled,
            }}
        >
            {children}
        </DynamicThemeContext.Provider>
    );
};

DynamicThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
